import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { posModalStyles as modalStyles } from "../../modalPrimitives";
import { useViewport } from "../../../../../hooks/useViewport";
import { R } from "../../orderingTheme";
import {
  ModalHeader,
  ModalFooter,
  GhostButton,
  PrimaryButton,
} from "../../modalPrimitives";

interface PrintPosConfirmModalProps {
  open: boolean;
  onYes: () => void;
  onNo: () => void;
  loading?: boolean;
  zIndex?: number;
  // По подразбиране текстовете са за отчет. Фактурите подават свои —
  // диалогът е един и същ, документът не е.
  title?: string;
  subtitle?: string;
}

export const PrintPosConfirmModal = ({
  open,
  onYes,
  onNo,
  loading = false,
  zIndex = 2400,
  title,
  subtitle,
}: PrintPosConfirmModalProps) => {
  const { t } = useTranslation();
  const { isMobile, isNarrow } = useViewport();

  return (
    <Modal
      open={open}
      onCancel={onNo}
      footer={null}
      centered
      closable={false}
      destroyOnHidden
      width={isMobile ? undefined : 420}
      styles={modalStyles}
      style={{ maxWidth: "calc(100vw - 32px)" }}
      zIndex={zIndex}
    >
      <div
        style={{ background: R.surface, fontFamily: R.font, color: R.text }}
      >
        <ModalHeader
          icon={<ExclamationCircleOutlined />}
          title={title ?? t("generateReport.printPosConfirmTitle")}
          subtitle={subtitle ?? t("generateReport.printPosConfirmDescription")}
          onClose={onNo}
          isNarrow={isNarrow}
        />
        <ModalFooter isNarrow={isNarrow} narrowFirst>
          <GhostButton
            label={t("common.no")}
            onClick={onNo}
            disabled={loading}
          />
          <PrimaryButton
            label={t("common.yes")}
            onClick={onYes}
            loading={loading}
          />
        </ModalFooter>
      </div>
    </Modal>
  );
};
